import { render, staticRenderFns } from "./delivered_mr.vue?vue&type=template&id=32a40b12"
import script from "./delivered_mr.vue?vue&type=script&lang=js"
export * from "./delivered_mr.vue?vue&type=script&lang=js"
import style0 from "./delivered_mr.vue?vue&type=style&index=0&id=32a40b12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports